var api = "https://api.qingcigame.com/jpweb";
var u = navigator.userAgent;
if (!u.match(/(iPhone|iPod|Android|ios)/i)) {
    if (!u.match(/(Mobile)/i)) {
        $('.rocket').css("transform", "scale(1)");
        $('.rocket').css("right", "31%");
    }
}

window.onload = function() {
    // 页面初始化
    obj.init();
    setTimeout(() => window.scrollTo(0, 0), 150)
}
var obj = {
    init: function() {
        const now = new Date();
        const start = new Date("2025-06-05T23:00:00+08:00");
        const end = new Date("2025-07-17T22:59:00+08:00");

        if (now < start || now > end) {
            document.write('<h2 style="text-align:center;padding-top:100px;color:#333;font-family:sans-serif;">イベント終了</h2>');
            return;
        }
        this.preloading(); // 预加载
        this.scroll(); // 滚动事件
        this.bind(); // 所有绑定事件
        this.getUrl(); // 获取链接
        this.setInterval(); // 定时器
    },
    // 图片资源预加载
    preloading: function() {
        if (event.persisted || window.performance && window.performance.navigation.type == 2) {
            window.location.reload();
        }
        //图片预加载
        var queue = new createjs.LoadQueue();
        var load = layer.load(2, { shade: [0.1, '#fff'] });
        queue.on("progress", function(e) {
            // //加载中的进度
        }, this);
        queue.on("complete", function(e) {
            layer.close(load);
            $('.index').addClass('index-show');
        }, this);
        queue.loadManifest([
            //加载图片，不包括后台的       
            '/3rd-anniversary/images/index_bg-d236af5f52.png',
            '/3rd-anniversary/images/header_bg-961b37d7a5.png',
            '/3rd-anniversary/images/top_banner_bg-3920c8c68f.png',
            '/3rd-anniversary/images/page_welfare_2-54e63a2fa5.png',
            '/3rd-anniversary/images/page_organ_2-0b1d9481b5.png',
            '/3rd-anniversary/images/page_strengthen_2-a6044bc816.png',
        ]);
    },
    getUrl: function() {
        $.ajax({
            url: api + "/index",
            type: "GET",
            xhrFields: {
                withCredentials: true
            },
            success: function(json) {
                if (json.code == 200) {
                    var url = json.data.articleList.ulr;
                    // url地址
                    $('.ios-btn').attr('href', url[0].get_url); // App_Store
                    $('.google-btn').attr('href', url[1].get_url); // Google_Play
                    var official_url = 'https://snail.qcplay.co.jp/index.html?from=special';
                    $('.official-btn').attr('href', official_url); // 官网

                    // 下载链接
                    if (navigator.userAgent.match(/(iPhone|iPod|ios)/i)) {
                        $('.download-btn').attr('href', url[0].get_url); // App_Store
                    } else {
                        $('.download-btn').attr('href', url[1].get_url); // Google_Play
                    }

                    // 社媒链接
                    $('.twitter-btn').attr('href', url[2].get_url); // twitter
                    $('.discord-btn').attr('href', url[9].get_url); // Discord
                    $('.line-open-chat-btn').attr('href', url[8].get_url); // open_chat
                    var youtube_url = 'https://www.youtube.com/@%E5%85%AC%E5%BC%8F%E6%9C%80%E5%BC%B7%E3%81%A7%E3%82%93%E3%81%A7%E3%82%93';
                    $('.youtube-btn').attr('href', youtube_url); // youtube
                    $('.line-btn').attr('href', url[3].get_url); // LINE
                    $('.fb-btn').attr('href', url[4].get_url); // Facebook
                } else {
                    layer.msg("サーバーに接続できません", { time: 2000 });
                }
            },
            error: function() {
                layer.msg("サーバーに接続できません", { time: 2000 });
            },
            complete: function() {
                // layer.close(index);
            }
        })
    },
    // 全屏滚动判断
    scroll: function() {
        $(window).scroll(function() {
            var scrollTop = $(this).scrollTop();
            var windowHeight = $(this).height();
            var returnTop = $('.bottom-box').offset().top;
            scrollTop + windowHeight * 0.7 > returnTop ? $('.rocket').fadeIn() : $('.rocket').fadeOut();
        });

        $('.rocket').click(function(event) {
            var _this = $(this);
            _this.addClass('rocket-ani')
            $('html, body').animate({ scrollTop: 0 }, 1000);
            setTimeout(function() { _this.fadeOut() }, 1000);
            setTimeout(function() { _this.removeClass('rocket-ani') }, 1500);
        });
    },
    bind: function() {
        $('.monitor-btn').on('click', function() {
            var mon_btn = $(this).attr('data-event');
            obj.countNum(mon_btn);
        })

        $('.change-btn-box .change-btn').on('click', function() {
            $('.change-btn').removeClass('on');
            $(this).addClass('on');

            var btnClass = $(this).attr('class');
            var match = btnClass.match(/btn-(\d+)/);

            if (match) {
                // ✅ 滚动到吸顶顶部并触发吸顶，避免后面滚动时闪
                var targetTop = $('.page .main').offset().top + 20;
                $('html, body').stop().animate({ scrollTop: targetTop }, 400);

                var index = match[1];
                index != 1 ? $('.index').addClass('ts') : $('.index').removeClass('ts');

                $('.act-page ').removeClass('active');
                $('.main .page-' + index).addClass('active');
            }
        });

        $('.change-btn-box .btn-04').click(function(event) {
            $('.unknown-popup').fadeIn();
        });

        $('.unknown-popup .close-bg').click(function(event) {
            $('.unknown-popup').fadeOut();
        });

        var hasAnimated = false; // 标记避免重复触发

        // 获取吸顶元素的初始位置（页面中的定位）
        var $sticky = $('.top-nav');
        var stickyTop = $sticky.offset().top;

        // 检测滚动位置
        $(window).on('scroll', function() {
            var scrollTop = $(window).scrollTop();

            // 到达吸顶点，添加 fixed
            if (scrollTop >= stickyTop + 30) {
                $('.before-nav-cover').css("opacity", "0");
                $sticky.addClass('sticky-fixed');
            } else {
                $('.before-nav-cover').css("opacity", "1");
                $sticky.removeClass('sticky-fixed');
            }

            if (!$('.btn-02').hasClass('on')) return;
            if (hasAnimated) return;

            var triggerTop = $('.page-02 .character-box').offset().top;
            var windowHeight = $(window).height();
            // 判断“角色区域”是否已进入视口 (超过 60%)
            if (scrollTop + windowHeight * 0.6 > triggerTop) {
                hasAnimated = true;

                var $chars = $('.ani-item');

                // 依次触发淡入滑入动画
                $chars.each(function(index, el) {
                    setTimeout(function() {
                        $(el).addClass('char-in-view');

                        // 最后一个出现后启动上下浮动
                        if (index === $chars.length - 1) {
                            setTimeout(function() {
                                $chars.each(function() {
                                    $(this).addClass('floating');
                                });
                            }, 600); // 动画结束延迟
                        }

                    }, index * 300); // 每个角色延迟 300ms
                });
            }
        });
    },
    setInterval: function() {
        // 开始"信号干扰"和恢复时间（均为日本时间 UTC+9）
        const changeTime = new Date("2025-06-08T11:00:00+08:00");
        const restoreTime = new Date("2025-06-25T11:00:00+08:00");
        const now = new Date();

        // 初始资源
        let icon = "https://download4.qcplay.com/qcgame-api/a8Ecx9plbvpfrwmeP266NVohFWt8S9NUGaZWOXhu.png";
        let head_icon = "https://download4.qcplay.com/qcgame-api/D1JK96TI8ZVZN9fU59XGfTy7nhDQj2W1t2GgoHzT.png";
        let bottom_icon = "/3rd-anniversary/images/app_box_1-3d25014fc4.png";

        // 替换icon的时间段
        if (now >= changeTime && now < restoreTime) {
            icon = "https://download4.qcplay.com/qcgame-api/4PGBsJsrRvSsNgMxhzAR35UWh8ZaXW85G7mZ4prV.png";
            head_icon = "https://download4.qcplay.com/qcgame-api/GHykuNO1h4RN3u2x5l04IOPzTvylFGHx2Lz5zSCJ.png";
            bottom_icon = "/3rd-anniversary/images/app_box_2-f45dfa2b41.png";
        }

        // 替换icon
        $('#favicon').attr('href', icon);
        $('.header-icon img').attr('src', head_icon);
        $('.app-info-box').css('background', `url(${bottom_icon}) no-repeat`);
    },
    // 阿里云埋点
    countNum: function(data) {
        setTimeout(() => {
            try {
                __bl.sum(data);
            } catch (e) {
                // console.log(e)
            }
        }, 500);
    }
}